import { render, staticRenderFns } from "./SelectConstituents.vue?vue&type=template&id=5ed9556e&scoped=true&"
import script from "./SelectConstituents.vue?vue&type=script&lang=js&"
export * from "./SelectConstituents.vue?vue&type=script&lang=js&"
import style0 from "./SelectConstituents.vue?vue&type=style&index=0&id=5ed9556e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9556e",
  null
  
)

export default component.exports